module.exports = __webpack_public_path__ + "static/img/bdwlw.752ebf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdwlw.png
// module id = P2/R
// module chunks = 0